import type { vendorApiNames } from '../names';
import type { UsernamePasswordAuthentication } from './auth';
import type {
  BaseUpdateVendorApiSettings,
  BaseVendorApi,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

export interface TsgidAuthentication {
  tsgid: string;
}

export type PrismaAuthentication = UsernamePasswordAuthentication &
  TsgidAuthentication;

/**
 * Prisma API settings available from API
 */
export type PublicPrismaApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['prisma']
> &
  VendorApiHttpAgentSettings &
  RejectUnauthorized &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings;

/**
 * Prisma API settings available in backend
 */
export type PrismaApiSettings = PublicPrismaApiSettings & PrismaAuthentication;

/**
 * Prisma API settings expected on API when updating
 */
export type UpdatePrismaApiSettings = BaseUpdateVendorApiSettings<
  PublicPrismaApiSettings,
  PrismaAuthentication
>;
